/**
 * Brand copy shared by the app, the landing page and the build (vite.config.ts
 * injects the social-card meta tags into index.html from these). Plain
 * constants only: this module is also loaded by Node at build time.
 */
export const BRAND_NAME = "Postflow";

export const BRAND_TAGLINE = "Social media scheduling for teams and agencies";

/** <title> of the landing page (and the static fallback in index.html). */
export const LANDING_TITLE = `${BRAND_NAME} — Social media scheduling for teams and agencies`;

/** Meta description of the landing page (and the static fallback in index.html). */
export const LANDING_DESCRIPTION =
  "Plan, review and publish social posts to X, LinkedIn, Instagram, Threads, Bluesky and six more networks from one calendar, with per-channel queues, team review and analytics.";

/** Social card image, generated by `npm run marketing:screens` (1200×630). */
export const OG_IMAGE_PATH = "/og.png";
export const OG_IMAGE_ALT = "The Postflow calendar with a week of scheduled posts";
